var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"category-keyword-list"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.category.name))]),_c('ul',{staticClass:"keyword-list"},_vm._l((_vm.category.keywords),function(k){return _c('li',{key:k.id},[_c('Keyword',[_vm._v(" "+_vm._s(k.value)+" ")])],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }